module.exports = __webpack_public_path__ + "static/img/shsqhhzyhzs_1.6a42646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shsqhhzyhzs_1.jpg
// module id = H9kG
// module chunks = 15